/*** IMPORTS FROM imports-loader ***/
var define = false;

import Globalize from "_globalize";

// Load all of the supplemental CLDR data that we need
Globalize.load(require("cldr-data/supplemental/likelySubtags.json"));
Globalize.load(require("cldr-data/supplemental/timeData.json"));
Globalize.load(require("cldr-data/supplemental/weekData.json"));
Globalize.load(require("cldr-data/supplemental/numberingSystems.json"));

// Load the english langauge specific cultures
Globalize.load(require("cldr-data/main/en/ca-gregorian.json"));
Globalize.load(require("cldr-data/main/en/numbers.json"));

export default Globalize;

